<template>
  <div @click="exportFile">
    <slot>Download {{ name }}</slot>
  </div>
</template>

<script>
import { read, utils, writeFileXLSX } from "xlsx";

export default {
  name: "vue-export-excel",

  props: {
    addMergeColumn: {
      type: Function,
    },
    beforeGenerate: {
      type: Function,
    },
    data: {
      type: Array,
      required: false,
      default: null,
    },
    fields: {
      type: Array,
      required: false,
    },
    name: {
      type: String,
      default: "data",
    },
    title: {
      default: null,
    },
  },

  data() {
    return {
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  mounted() {},

  methods: {
    exportFile: async function () {
      // call beforeGenerate
      if (typeof this.beforeGenerate === "function") {
        await this.beforeGenerate();
      }

      const wb = utils.book_new();

      console.log("this.data", this.data);
      for (const [keyWsData, valWsData] of Object.entries(this.data)) {
        console.log("valWsData", valWsData);

        const header = [];

        // set title
        if (valWsData.title) header.push([valWsData.title], [""]);

        // set header
        if (valWsData.header) {
          for (const [keyH, valH] of Object.entries(valWsData.header)) {
            const headerText = keyH;
            if (valH) headerText += `: ${valH}`;
            header.push([headerText]);
          }
        }

        // set timestamps
        header.push(
          [""],
          [`Export Time: ${this.$_sys.dateNow()}`],
          [`Export By: ${this.$_sys.userInfo().name}`],
          [""]
        );
        console.log("header", header);

        let isSkipHeader = false;
        if (valWsData.tableHeader) {
          header.push(...valWsData.tableHeader);
          isSkipHeader = true;
        }
        const ws = utils.aoa_to_sheet(header);
        console.log("valWsData.data", valWsData.data);
        if (
          typeof valWsData.tableDataType != undefined &&
          valWsData.tableDataType == "aoa"
        ) {
          utils.sheet_add_aoa(ws, valWsData.data, { origin: -1 });
        } else {
          utils.sheet_add_json(ws, valWsData.data, {
            origin: -1,
            skipHeader: isSkipHeader,
          });
        }
        utils.book_append_sheet(
          wb,
          ws,
          valWsData.name || `Data ${keyWsData + 1}`
        );

        // call addMergeColumn
        if (typeof this.addMergeColumn === "function") {
          let merges = await this.addMergeColumn({
            worksheet: ws,
            workbook: wb,
            data: valWsData,
            header: header,
          });
          if (merges.length) {
            merges = merges.map((v) => utils.decode_range(v));
            console.log("merges", merges);
            ws["!merges"] = merges;
          }
        }
      }

      writeFileXLSX(wb, `${this.name || "data"}.xlsx`);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/base/component/vue-export-excel.vue